// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".agree-unbound .el-checkbox__label{font-size:14px;color:#333;font-weight:500}", ""]);
// Exports
module.exports = exports;
